


// import React from 'react';
// import { FaMapMarkerAlt } from 'react-icons/fa';

// const locationData = [
//   {
//     title: "Bangalore – 1",
//     address: [
//       "BBMP Katha No. 185/73/9,",
//       "Ward No.192, Beretena Agrahara Village,",
//       "Hosur road, Bengaluru,",
//       "Karnataka 560100"
//     ]
//   },
//   {
//     title: "Bangalore – 2",
//     address: [
//       "Address Line 1,",
//       "Address Line 2,",
//       "City,",
//       "State 123456"
//     ]
//   },
//   {
//     title: "Bangalore – 3",
//     address: [
//       "Address Line 1,",
//       "Address Line 2,",
//       "City,",
//       "State 123456"
//     ]
//   },
//   {
//     title: "Bangalore – 3",
//     address: [
//       "Address Line 1,",
//       "Address Line 2,",
//       "City,",
//       "State 123456"
//     ]
//   },
//   {
//     title: "Bangalore – 3",
//     address: [
//       "Address Line 1,",
//       "Address Line 2,",
//       "City,",
//       "State 123456"
//     ]
//   },
//   {
//     title: "Bangalore – 4",
//     address: [
//       "Address Line 1,",
//       "Address Line 2,",
//       "City,",
//       "State 123456"
//     ]
//   }
// ];

// const LocationCard = ({ title, address }) => (
//   <div className="p-6 bg-white rounded-md">
//     <div className="flex items-center gap-2 mb-3 text-amber-400 text-xl">
//       <FaMapMarkerAlt />
//       <h3 className="text-lg font-semibold">{title}</h3>
//     </div>
//     <div className="space-y-1 text-left">
//       {address.map((line, index) => (
//         <p key={index} className="text-gray-700">{line}</p>
//       ))}
//     </div>
//     <div className="w-full h-80 rounded-md overflow-hidden border border-gray-200 mt-4 p-6"> {/* Reduced width to 3/4 */}
//       <iframe
//         src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.5!2d77.6!3d12.9!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTLCsDU0JzAwLjAiTiA3N8KwMzYnMDAuMCJF!5e0!3m2!1sen!2sin!4v1620000000000!5m2!1sen!2sin"
//         className="w-full h-full border-0 rounded-md"
//         loading="lazy"
//         allowFullScreen
//         referrerPolicy="no-referrer-when-downgrade"
//         title="Location map"
//       />
//     </div>
//   </div>
// );

// const LocationGrid = () => (
//   <div className="container mx-auto p-6">
//     <h2 className="text-2xl font-semibold text-gray-800 mb-6">Our Locations</h2>
//     <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//       {locationData.map((location, index) => (
//         <LocationCard key={index} {...location} />
//       ))}
//     </div>
//   </div>
// );

// export default LocationGrid;


import React from "react";
import { FaMapMarkerAlt } from "react-icons/fa";

const locationData = [
  {
    title: "Bangalore – 1",
    address: [
      "BBMP Katha No. 185/73/9,",
      "Ward No.192, Beretena Agrahara Village,",
      "Hosur road, Bengaluru,",
      "Karnataka 560100",
    ],
  },
  {
    title: "Bangalore – 2",
    address: [
      "Address Line 1,",
      "Address Line 2,",
      "City,",
      "State 123456",
    ],
  },
  {
    title: "Bangalore – 3",
    address: [
      "Address Line 1,",
      "Address Line 2,",
      "City,",
      "State 123456",
    ],
  },
  {
    title: "Bangalore – 4",
    address: [
      "Address Line 1,",
      "Address Line 2,",
      "City,",
      "State 123456",
    ],
  },
];

const LocationCard = ({ title, address }) => (
  <div className="p-6 bg-white rounded-md border border-gray-300 md:border-none">
    <div className="flex items-center gap-2 mb-3 text-black text-xl">
      <FaMapMarkerAlt />
      <h3 className="text-lg font-semibold">{title}</h3>
    </div>
    <div className="space-y-1 text-left">
      {address.map((line, index) => (
        <p key={index} className="text-black">
          {line}
        </p>
      ))}
    </div>
    <div className="w-full h-80 rounded-md overflow-hidden border border-gray-200 mt-4 p-0 md:p-6">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.5!2d77.6!3d12.9!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTLCsDU0JzAwLjAiTiA3N8KwMzYnMDAuMCJF!5e0!3m2!1sen!2sin!4v1620000000000!5m2!1sen!2sin"
        className="w-full h-full border-0 rounded-md"
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
        title="Location map"
      />
    </div>
  </div>
);

const LocationGrid = () => (
  <div className="container mx-auto p-6">
    <h2 className="text-2xl text-center text-[#FF9630] font-semibold mb-6">Our Locations</h2>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {locationData.map((location, index) => (
        <LocationCard key={index} {...location} />
      ))}
    </div>
  </div>
);

export default LocationGrid;
